(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory((function webpackLoadOptionalExternalModule() { try { return require("better-sqlite3"); } catch(e) {} }()));
	else if(typeof define === 'function' && define.amd)
		define(["better-sqlite3"], factory);
	else if(typeof exports === 'object')
		exports["GeoPackage"] = factory((function webpackLoadOptionalExternalModule() { try { return require("better-sqlite3"); } catch(e) {} }()));
	else
		root["GeoPackage"] = factory(root["better-sqlite3"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__2938__) => {
return 